var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-h-full gl-min-h-5 gl-w-2 gl-flex-shrink-0 gl-self-stretch gl-rounded-full",style:(_vm.barBgClass)})
}
var staticRenderFns = []

export { render, staticRenderFns }